import React from 'react';
import PropTypes from 'prop-types';
import { statsToArray } from './helpers';
import { StatList } from './styles';
import { Container } from '../styled/containers';
import { consistentString } from '../../utils/content-formatting';
import SingleStat from './single-stat';
import { RichTextPropTypes } from '../../prop-types';

/**
 * The Stats component shows a large headline, with a smaller subtitle
 * and then a rich text. It is used for displaying striking statistics.
 *
 * It can be configured in a 2x2 grid, or a 3 column layout.
 */
const Stats = ({ type, stats, removeMarginBottom }) => {
  if (!stats || !stats.length) return null;

  if (type === 'grid') {
    // If grid is chosen then we are expecting items that need to
    // be split into rows due background color breaking the container
    const rows = [];
    const statsPerRow = 2;
    for (let i = 0; i < stats.length; i += statsPerRow) {
      rows.push(stats.slice(i, i + statsPerRow));
    }

    return (
      <Container $padding>
        <StatList $statLayout={type} $removeMarginBottom={removeMarginBottom}>
          {rows.map((items, rowIndex) =>
            items.map(({ title, subtitle, text }, statIndex) => (
              <SingleStat
                title={title}
                subtitle={subtitle}
                text={text}
                statLayout={type}
                statIndex={statIndex}
                rowIndex={rowIndex}
                key={statIndex}
              />
            ))
          )}
        </StatList>
      </Container>
    );
  }

  // Will only show first 3 even if more are chosen
  const first3Stats = [...stats].slice(0, 3);
  return (
    <Container $padding>
      <StatList $statLayout={type} $removeMarginBottom={removeMarginBottom}>
        {first3Stats.map(({ title, subtitle, text }, statIndex) => (
          <SingleStat
            title={title}
            subtitle={subtitle}
            text={text}
            statLayout={type}
            statIndex={statIndex}
            key={statIndex}
          />
        ))}
      </StatList>
    </Container>
  );
};
Stats.propTypes = {
  type: PropTypes.oneOf(['grid', 'line']),
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
      text: RichTextPropTypes,
    })
  ),
  removeMarginBottom: PropTypes.bool,
};

Stats.defaultProps = {
  type: 'grid',
};

export default Stats;

export const StatsAssembly = ({ contentfulData }) => (
  <Stats
    type={consistentString(contentfulData.displayType)}
    stats={statsToArray(contentfulData)}
    removeMarginBottom={contentfulData.removeMarginBottom}
  />
);

StatsAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
